import type { TContentGatePopupElement } from '@shared/dream-components';
import { ContentGatePopupElement } from '@shared/dream-components';
import { useRef } from 'react';
import type { ReactNode } from 'react';
import { usePostPageContext } from '~/context/usePostPageContext';

import { useRouteLoaderData } from 'react-router';
import useClipContentHeight from '~/hooks/useClipContentHeight';
import { useContentGatePopup } from '~/hooks/useContentGatePopup';
import type { RootLoaderData } from '~/root';
import { processContentGatePopupNode } from '../utils/processors';

interface Props {
  node: TContentGatePopupElement;
  children: ReactNode | ReactNode[];
}

const ContentGatePopup = ({ node, children }: Props) => {
  const contentGateElementRef = useRef<HTMLDivElement>(null);
  const { publication } = useRouteLoaderData('root') as RootLoaderData;
  const { isSubscriberGateEnabled } = usePostPageContext() || { isSubscriberGateEnabled: false };

  const { isOpen } = useContentGatePopup({
    useIntersectionLogic: false,
    isEnabled: isSubscriberGateEnabled,
    contentGateElementRef,
  });

  useClipContentHeight({
    enabled: isSubscriberGateEnabled,
    scrollHeight: 200,
  });

  if (!isSubscriberGateEnabled) {
    return null;
  }

  const processedNode = node
    ? processContentGatePopupNode(node, {
        publicationUrl: publication?.url,
      })
    : node;

  return (
    <div ref={contentGateElementRef}>
      <ContentGatePopupElement element={processedNode} isLive isOpen={isOpen}>
        {children}
      </ContentGatePopupElement>
    </div>
  );
};

export { ContentGatePopup };
